import type { ReactNode } from 'react';

import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

type Props = {
  children?: ReactNode;
};

type IOSProps = Props & {
  exceptMarketAuthorizedIosApp?: boolean;
};
export const NotIOsAppFeature = ({
  children,
  exceptMarketAuthorizedIosApp,
}: IOSProps) => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  if (isIosApp && !(exceptMarketAuthorizedIosApp && isMarketAuthorizedIosApp)) {
    return null;
  }
  return <>{children}</>;
};

export const IOsAppFeature = ({
  children,
  exceptMarketAuthorizedIosApp,
}: IOSProps) => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  if (isIosApp && !(exceptMarketAuthorizedIosApp && isMarketAuthorizedIosApp)) {
    return <>{children}</>;
  }
  return null;
};

export const NotAndroidAppFeature = ({ children }: Props) => {
  const { isAndroidApp } = useIsMobileApp();

  if (isAndroidApp) {
    return null;
  }
  return <>{children}</>;
};

export const NotMobileAppFeature = ({
  children,
  exceptMarketAuthorizedIosApp,
}: IOSProps) => {
  const { isAndroidApp, isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();

  if (
    (isIosApp && !(exceptMarketAuthorizedIosApp && isMarketAuthorizedIosApp)) ||
    isAndroidApp
  ) {
    return null;
  }
  return <>{children}</>;
};

export const MobileAppFeature = ({
  children,
  exceptMarketAuthorizedIosApp,
}: IOSProps) => {
  const { isAndroidApp, isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  if (
    (isIosApp && !(exceptMarketAuthorizedIosApp && isMarketAuthorizedIosApp)) ||
    isAndroidApp
  ) {
    return <>{children}</>;
  }
  return null;
};
